import React, { Component } from 'react';
import { List, Map } from 'immutable';
import PropTypes from 'prop-types';
import connect from '../store/connect';
import ProductList from '../components/ProductList';
import Filters from '../components/Filters';
import MobileNav from '../components/MobileNav';
import { Heading } from '../styles/Heading';
import SlideOutContainer from '../components/SlideOutContainer';
import Accordion from '../components/Accordion';
import AccordionItemText from '../components/AccordionItemWithText';
import FiltersList from '../components/FiltersList';
import SortingList from '../components/SortingList';
import { Pagination, PaginationDivider } from '../styles/Pagination';
import { PaginationContainer } from '../styles/PaginationContainer';
import { Icon } from '../styles/Icon';
import { FilterOption } from '../styles/FilterOption';
import { Container } from '../styles/Container';
import { DividerLine } from '../styles/DividerLine';
import { NoProductsFound } from '../styles/NoProductsFound';
import { setViewstate } from '../actions/actionCreators';
import { LoadingSpinner } from './LoadingSpinner';
import { getFilteredProducts } from '../selectors/reselectCategory';
import { size } from '../styles/helpers/variables';

class ProductListWithFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalActive: false,
      scrollHeight: 0,
      pages: 1,
      productsPerPage: 24
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.setPages = this.setPages.bind(this);
  }
  componentDidMount() {
    const informationCardOffset = !this.props.informationCard.isEmpty() ? 2 : 0;
    this.setPages(this.props.filteredProducts, informationCardOffset);
  }

  componentWillReceiveProps(nextProps) {
    const informationCardOffset = !nextProps.informationCard.isEmpty() ? 2 : 0;
    this.setPages(nextProps.filteredProducts, informationCardOffset);

    // commented out since it reset product list pagination on navigation - https://cloudnineab.freshdesk.com/a/tickets/7671
    /*
    if (!nextProps.filteredProducts.equals(this.props.filteredProducts)) {
      this.props.setViewstate('pagination', 0);
    }
    */

    // this is a fix for when a pagination number is higher than the amount of pages
    if (
      nextProps.filteredProducts.size > 0 &&
      nextProps.viewstate.get('pagination') * this.state.productsPerPage - informationCardOffset + 1 >
        nextProps.filteredProducts.size
    ) {
      this.props.setViewstate('pagination', 0);
    }
  }
  setPages(filteredProducts, informationCardOffset) {
    this.setState(() => ({
      pages: filteredProducts.size
        ? Math.ceil((filteredProducts.size + informationCardOffset) / this.state.productsPerPage)
        : 1
    }));
  }
  toggleModal(modal) {
    if (!this.state.isModalActive) {
      this.setState({
        isModalActive: modal,
        scrollHeight: window.pageYOffset
      });
    } else {
      this.setState({
        isModalActive: false
      });
    }
  }

  areProductsFiltered(originalProducts, filteredProducts) {
    if (originalProducts && filteredProducts) {
      return originalProducts.size !== filteredProducts.size;
    }
    return false;
  }

  changePage(page) {
    if (this.filterSection) {
      this.filterSection.scrollIntoView({ block: 'start' });
    }
    this.props.setViewstate('pagination', page);
  }

  paginate(products) {
    const { productsPerPage } = this.state;
    const { viewstate, informationCard } = this.props;

    const informationCardOffset = !informationCard.isEmpty() ? -2 : 0;

    const start = viewstate.get('pagination')
      ? viewstate.get('pagination') * productsPerPage + informationCardOffset
      : 0;
    const end = start + productsPerPage + informationCardOffset;

    if (products.size) {
      return products.slice(start, end);
    }
    return products;
  }

  renderPagination() {
    const { viewstate } = this.props;

    const paginationArray = [];
    let neighborPagesToShow;

    // show different amount of pagination links depending on screen size.
    if (viewstate.get('pageWidth') <= size.small) {
      neighborPagesToShow = 1;
    } else if (viewstate.get('pageWidth') <= size.medium) {
      neighborPagesToShow = 2;
    } else if (viewstate.get('pageWidth') <= size.large) {
      neighborPagesToShow = 3;
    } else {
      neighborPagesToShow = 4;
    }

    if (this.state.pages <= neighborPagesToShow * 2 + 3) {
      // if there are less pages then the pagination will show, show all the pages.
      for (let i = 0; i < this.state.pages; i += 1) {
        paginationArray.push(
          <Pagination key={i} active={viewstate.get('pagination') === i} onClick={() => this.changePage(i)}>
            {i < 9 ? `0${i + 1}` : i + 1}
          </Pagination>
        );
      }
    } else {
      // else, we show the truncated version of our pagination pages.
      const truncatedPagination = [0];
      for (let i = 0; i < this.state.pages; i += 1) {
        if (
          viewstate.get('pagination') >= i - neighborPagesToShow &&
          viewstate.get('pagination') <= i + neighborPagesToShow
        ) {
          if (!truncatedPagination.includes(i)) {
            truncatedPagination.push(i);
          }
        }
      }

      // adds the last pagination page, because it should always be visible.
      if (!truncatedPagination.includes(this.state.pages - 1)) {
        truncatedPagination.push(this.state.pages - 1);
      }

      // a for loop that adds the components for the truncated pagination, including dividers when pagination numbers are not in a series.
      for (let i = 0; i < truncatedPagination.length; i += 1) {
        const difference = truncatedPagination[i] - truncatedPagination[i - 1];

        if (difference !== 1 && !Number.isNaN(difference)) {
          paginationArray.push(<PaginationDivider>&#8230;</PaginationDivider>);
        }

        paginationArray.push(
          <Pagination
            key={truncatedPagination[i]}
            active={viewstate.get('pagination') === truncatedPagination[i]}
            onClick={() => this.changePage(truncatedPagination[i])}
          >
            {truncatedPagination[i] < 9 ? `0${truncatedPagination[i] + 1}` : truncatedPagination[i] + 1}
          </Pagination>
        );
      }
    }

    return paginationArray;
  }

  renderPaginationInModal() {
    const { viewstate } = this.props;
    const paginations = [];

    for (let i = 0; i < this.state.pages; i += 1) {
      paginations.push(
        <FilterOption radioButton key={i} active={viewstate.get('pagination') === i} onClick={() => this.changePage(i)}>
          Sidan {i + 1}
        </FilterOption>
      );
    }

    return paginations;
  }

  render() {
    const {
      filteredProducts,
      allProducts,
      viewstate,
      includeRelevance,
      informationCard,
      request,
      includeCategoryFilter
    } = this.props;
    const { pages } = this.state;

    const pageWidth = viewstate.get('pageWidth');
    const sortAscending = viewstate.get('sortAscending');

    // const filteredCategoryProductsWithSplash = filteredProducts.size >= 6 ? filteredProducts.toList().insert(6, fromJS({ test: 'test' })) : filteredProducts;
    const finalProducts = this.paginate(filteredProducts);
    const renderPagination = this.renderPagination();
    const paginationInModal = this.renderPaginationInModal();

    return (
      <div style={{ paddingBottom: '30px' }}>
        <div
          ref={item => {
            this.filterSection = item;
          }}
        >
          {pageWidth >= 940 ? (
            <Filters
              includeRelevance={includeRelevance}
              products={this.props.allProducts}
              includeCategoryFilter={includeCategoryFilter}
            />
          ) : (
            <MobileNav
              toggleModal={this.toggleModal}
              color="transparent"
              currentPage={viewstate.get('pagination') + 1}
              pages={pages}
            />
          )}
        </div>

        {pageWidth < 940 && (
          <SlideOutContainer
            fromLeft
            toggleModal={this.toggleModal}
            active={this.state.isModalActive === 'filter'}
            scrollHeight={this.state.scrollHeight}
          >
            <Heading.p>Filtrera</Heading.p>
            {includeCategoryFilter ? (
              <Accordion>
                <AccordionItemText title="Underkategori" number={viewstate.getIn(['filter', 'category'], List()).size}>
                  <FiltersList
                    type="category"
                    products={this.props.allProducts}
                    selector={['category', 'name']}
                    margin={0}
                    marginBottom={20}
                    width={[1]}
                  />
                </AccordionItemText>
                <AccordionItemText title="Färg" number={viewstate.getIn(['filter', 'color'], List()).size}>
                  <FiltersList
                    forColor
                    type="color"
                    products={this.props.allProducts}
                    selector={['specifications', 'color']}
                    margin={0}
                    marginBottom={20}
                    width={[1]}
                  />
                </AccordionItemText>
                <AccordionItemText title="Varumärke" number={viewstate.getIn(['filter', 'manufacturer'], List()).size}>
                  <FiltersList
                    type="manufacturer"
                    products={this.props.allProducts}
                    selector={['brand', 'name']}
                    margin={0}
                    marginBottom={20}
                    width={[1]}
                  />
                </AccordionItemText>
              </Accordion>
            ) : (
              <Accordion>
                <AccordionItemText title="Färg" number={viewstate.getIn(['filter', 'color'], List()).size}>
                  <FiltersList
                    forColor
                    type="color"
                    products={this.props.allProducts}
                    selector={['specifications', 'color']}
                    margin={0}
                    marginBottom={20}
                    width={[1]}
                  />
                </AccordionItemText>
                <AccordionItemText title="Varumärke" number={viewstate.getIn(['filter', 'manufacturer'], List()).size}>
                  <FiltersList
                    type="manufacturer"
                    products={this.props.allProducts}
                    selector={['brand', 'name']}
                    margin={0}
                    marginBottom={20}
                    width={[1]}
                  />
                </AccordionItemText>
              </Accordion>
            )}
          </SlideOutContainer>
        )}

        {pageWidth < 940 && (
          <SlideOutContainer
            toggleModal={this.toggleModal}
            active={this.state.isModalActive === 'page'}
            scrollHeight={this.state.scrollHeight}
          >
            <Heading.p>Välj sida</Heading.p>
            <DividerLine />
            {paginationInModal}
            <DividerLine />
          </SlideOutContainer>
        )}

        {pageWidth < 940 && (
          <SlideOutContainer
            toggleModal={this.toggleModal}
            active={this.state.isModalActive === 'sort'}
            scrollHeight={this.state.scrollHeight}
          >
            <Heading.p>Sortera</Heading.p>
            <DividerLine />
            <SortingList includeRelevance={this.props.includeRelevance} margin={0} width={1} marginBottom={20} />
            <DividerLine />
          </SlideOutContainer>
        )}

        {request.get('status') === 'LOADING' && allProducts.isEmpty() ? <LoadingSpinner /> : false}

        {request.get('status') === 'ERROR' ? (
          <Container>
            <NoProductsFound>
              Vi jobbar med att berika vår webbplats med produkter. Nya produkter kommer inom kort under denna kategori.
            </NoProductsFound>
          </Container>
        ) : (
          false
        )}

        {!allProducts.isEmpty() ? (
          <Container>
            {finalProducts.size >= 1 ? (
              <ProductList
                includeRelevance={includeRelevance}
                data={finalProducts}
                pageWidth={pageWidth}
                onProductCardHover={this.props.productCardHover}
                modified={this.areProductsFiltered(allProducts, filteredProducts, sortAscending)}
                informationCard={informationCard}
                activeFilterColor={
                  viewstate.getIn(['filter', 'color']) && Object.keys(viewstate.getIn(['filter', 'color']).toJS())[0]
                }
              />
            ) : (
              <NoProductsFound>
                {allProducts.size === 0 ? (
                  <span>
                    Vi jobbar med att berika vår webbplats med produkter. Nya produkter kommer inom kort under denna
                    kategori.
                  </span>
                ) : (
                  <span>
                    Tyvärr hittade vi inte produkter efter dina filtreringsval – Testa göra andra val för att uppdatera
                    listan.
                  </span>
                )}
              </NoProductsFound>
            )}

            {pages > 1 && (
              <PaginationContainer>
                {viewstate.get('pagination') > 0 &&
                  pageWidth >= 940 && <Icon left onClick={() => this.changePage(viewstate.get('pagination') - 1)} />}
                {renderPagination}
                {viewstate.get('pagination') + 1 < pages &&
                  pageWidth >= 940 && <Icon right onClick={() => this.changePage(viewstate.get('pagination') + 1)} />}
              </PaginationContainer>
            )}
          </Container>
        ) : (
          false
        )}
      </div>
    );
  }
}

ProductListWithFilters.defaultProps = {
  includeCategoryFilter: false,
  allProducts: Map(),
  filteredProducts: Map(),
  productCardHover: () => {},
  viewstate: Map(),
  includeRelevance: false,
  informationCard: Map(),
  request: Map()
};

ProductListWithFilters.propTypes = {
  includeCategoryFilter: PropTypes.bool,
  setViewstate: PropTypes.func.isRequired,
  viewstate: PropTypes.instanceOf(Map),
  allProducts: PropTypes.instanceOf(Map),
  filteredProducts: PropTypes.instanceOf(Map),
  productCardHover: PropTypes.func,
  includeRelevance: PropTypes.bool,
  informationCard: PropTypes.instanceOf(Map),
  request: PropTypes.instanceOf(Map)
};

export default connect(
  ProductListWithFilters,
  { setViewstate },
  (store, props) => ({
    viewstate: store.viewstate,
    filteredProducts: getFilteredProducts(store, props.allProducts)
  })
);



// WEBPACK FOOTER //
// ./src/components/ProductListWithFilters.js